// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__QwPvt","sidebar":"Header_sidebar__833NC","hamburger_icon_container":"Header_hamburger_icon_container__ZVYkA","nav_link":"Header_nav_link__zWKYO"};